import Survey from '@/models/Survey';

const GET_SURVEYS = 'get_surveys';
const GET_SURVEYS_REQUEST = 'get_surveys_request';
const GET_SURVEYS_SUCCESS = 'get_surveys_success';
const GET_SURVEYS_ERROR = 'get_surveys_error';

export { GET_SURVEYS };

export default {
    state: {
        surveys: [],
        loading: false,
        surveysErrors: [],
        surveysMeta: {},
    },
    mutations: {
        [GET_SURVEYS_REQUEST]: (state) => {
            state.surveys = [];
            state.loading = true;
            state.surveysErrors = [];
            state.surveysMeta = {};
        },
        [GET_SURVEYS_SUCCESS]: (state, { surveys, meta }) => {
            state.surveys = surveys;
            state.loading = false;
            state.surveysErrors = [];
            state.surveysMeta = meta;
        },
        [GET_SURVEYS_ERROR]: (state, { errors }) => {
            state.surveys = [];
            state.loading = false;
            state.surveysErrors = errors;
            state.surveysMeta = {};
        },
    },
    actions: {
        [GET_SURVEYS]: ({ commit, state, rootState }, { trajectoryId, params = {} }) => {
            if (!trajectoryId) {
                trajectoryId = rootState.trajectory.trajectory.id;
            }
            commit(GET_SURVEYS_REQUEST);
            return new Promise((resolve, reject) => {
                // If no page specified at dispatch
                if (!params.page) {
                    // Use the current one if present, the first one othewise
                    if (state.surveysMeta.current_page) {
                        params.page = state.surveysMeta.current_page;
                    } else {
                        params.page = 1;
                    }
                }

                const TrajectorySurveys = Survey.makeModel(`/trajectories/${trajectoryId}/surveys`);
                TrajectorySurveys.collection(params)
                    .then(({ items, meta }) => {
                        const surveys = items;
                        commit(GET_SURVEYS_SUCCESS, { surveys, meta });
                        resolve(items);
                    })
                    .catch(({ status, errors }) => {
                        commit(GET_SURVEYS_ERROR, { errors });
                        reject({ status, errors });
                    });
            });
        },
    },
    getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/surveys.js